// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__35xu5","label":"CategoryService_label__6n-_F","location":"CategoryService_location__2R1zm"};